module.exports = __webpack_public_path__ + "img/empty-cart.356d2836.png";